export default __webpack_public_path__ + "static/media/crude-graph-on2.6000f814.svg";